import React, { useEffect, useState } from 'react'
import { userEndpoints } from 'src/api'
import { Wrapper } from './styles'
import moment from 'moment'
import 'moment/locale/ro' // without this line it didn't work
import { useSelector } from 'react-redux'
import { usersSelector } from 'src/state/selectors'
moment.locale('ro')

type StatsDateEntry = {
  date: string
  value: string
}

type Stats = {
  today: string
  yesterday: string
  daysAgo7: string
  daysAgo30: string
  last7DaysGraph: StatsDateEntry[]
}

export default function NavStatsPanel() {
  const [realStats, setRealStats] = useState<Stats | undefined>()
  const { user } = useSelector(usersSelector)

  useEffect(() => {
    if (!realStats) {
      getMenuStats()
    }
  }, [user])

  const getMenuStats = async () => {
    setRealStats(await userEndpoints.getMyStats())
  }

  if (!realStats) {
    return null
  }

  const maxValue = Math.max(...realStats.last7DaysGraph.map(x => +x.value))

  const last7Days = []

  for (let i = 6; i >= 0; i--) {
    let date = moment()
    date.subtract(i, 'day')

    const value = realStats.last7DaysGraph.find(x => x.date === date.format('YYYYMMDD'))?.value
    last7Days.push({ date, value: value || 0 })
  }

  return (
    <Wrapper>
      <label>Accesări meniu</label>
      <div className="content">
        <div className="stat">
          <div className="value">{realStats.today}</div>
          <div className="label">Astăzi</div>
        </div>
        <div className="stat">
          <div className="value">{realStats.yesterday}</div>
          <div className="label">Ieri</div>
        </div>
        <div className="stat">
          <div className="value">{realStats.daysAgo30}</div>
          <div className="label">Ultimele 30 de zile</div>
        </div>
        <div className="graph">
          {last7Days.map(x => (
            <div
              key={x.date.toString()}
              className="bar"
              style={{ height: `${(+x.value / maxValue) * 100}%`, opacity: +x.value > 0 ? 1 : 0.5 }}
            >
              <div className="value">{x.value}</div>
              <span>{x.date.format('dd')}</span>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  )
}
